import { render, staticRenderFns } from "./waiter.vue?vue&type=template&id=ab13fc54&scoped=true&"
import script from "./waiter.vue?vue&type=script&lang=js&"
export * from "./waiter.vue?vue&type=script&lang=js&"
import style0 from "./waiter.vue?vue&type=style&index=0&id=ab13fc54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab13fc54",
  null
  
)

export default component.exports